import { useMemo, useEffect } from "react";
import { throttle } from "lodash";

export function useThrottleCallback<T extends (...args: any[]) => void>(
  callback: T,
  delay: number
): T {
  const throttledFn = useMemo(() => throttle(callback, delay), [callback, delay]);

  useEffect(() => {
    return () => {
      throttledFn.cancel(); // Cleanup on unmount
    };
  }, [throttledFn]);

  return throttledFn as unknown as T;
}
